export const unicodeSymbols = {
    arrowRight: String.fromCharCode(8594), // стрелка вправо →
    asymp: String.fromCharCode(8776), // приблизительно
    blackCircle: String.fromCharCode(9679), // жирная точка по центру строки (в вертикальном смысле)
    blackRightwardsArrowhead: String.fromCharCode(10148), // ➤
    bull: String.fromCharCode(8226), // средняя точка по центру строки(в вертикальном смысле)
    middleDot: String.fromCharCode(183), // наименее жирная точка по центру строки (в вертикальном смысле)
    copyright: String.fromCharCode(169), // знак копирайта ©,
    degree: String.fromCharCode(176), // градус °
    enSpace: String.fromCharCode(0x2002), // EN SPACE (nut)
    hellip: String.fromCharCode(8230), // многоточие
    laquo: String.fromCharCode(171), // кавычки-ёлочки (левые)
    mdash: String.fromCharCode(8212), // длинное тире
    middot: String.fromCharCode(183), // маленькая точка по центру строки (в вертикальном смысле)
    nbdash: String.fromCharCode(8209), // неразрывное тире
    nbsp: String.fromCharCode(160), // неразрывный пробел
    ndash: String.fromCharCode(8211), // среднее тире
    raquo: String.fromCharCode(187), // кавычки-ёлочки (правые)
    space: String.fromCharCode(32), // обычный пробел
    thinsp: String.fromCharCode(8201), // короткий пробел
    times: String.fromCharCode(215), // мультипликатор ×,
    minus: String.fromCharCode(0x2212), // минус −,
    plus: String.fromCharCode(43), // плюс +,
};